import { render, staticRenderFns } from "./linkStockPriceGroup.vue?vue&type=template&id=fa2d40a0&"
import script from "./linkStockPriceGroup.vue?vue&type=script&lang=js&"
export * from "./linkStockPriceGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports